module.exports = __webpack_public_path__ + "img/sy.9485053c.png";